module.exports = __webpack_public_path__ + "img/icon_pro_base_tr.b9d8d943.png";